import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedTooltipContentComponent } from "./med-tooltip-content.component";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";

@NgModule({
  declarations: [
    MedTooltipContentComponent,
  ],
  imports: [
    CommonModule,
    MedDirectiveSharedModule,
  ],
  exports: [
    MedTooltipContentComponent,
  ],
})
export class MedTooltipContentModule { }
